<template>
  <span 
    :class="classList"
    class="MapBoxZoom"
    @click.stop.prevent="toggle">
    <span>
      <font-awesome-icon class="pin" :icon="['fal', 'map-marker-alt']" /> 
    </span>
    {{ label }}
  </span>
</template>

<script>
export default {
  name: 'MapBoxZoom',
  props: {
    label: {
      type: String,
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      active: false
    }
  },
  computed: {
    classList() {
      let list = {
        'MapBoxZoom--compact' : this.compact,
        'MapBoxZoom--labeled' : ! this.compact,
        'MapBoxZoom--active'  : this.active
      }
      return list;
    },
    data() {
      if (this.type === 'project') {
        return this.$store.getters.getProjectBySlug({
          slug: this.slug
        });
      }

      return {}
    }
  },
  methods: {
    toggle() {
      // We need the map to be ready...
      if ( ! this.$store.map) {
        return;
      }

      if (this.type === 'project') {
        // Do not combine with above if statement. Two distinct type of checks!
        if (this.data.location) {
          this.$store.map.flyTo({
            center: [
              parseFloat(this.data.location.lng, 10),
              parseFloat(this.data.location.lat, 10)
            ],
            zoom: 14
          });
          this.$store.map.setFilter('verhalen', ['has', 'project_'+this.slug]);
          this.$store.map.setFilter('verhalen_muted', ['!has', 'project_'+this.slug]);
        }
      }
      else if (this.type === 'gemeente') {
        let gemeente = this.$store.getters.getGemeenteBySlug({
          slug: this.slug
        });
        if (gemeente) {
          let name = gemeente.name.replace('Gemeente ', '');
          this.$store.map.setFilter('gemeenten', ['all', ['==', 'GM_NAAM', name]])

          // Zoom...
          this.$store.dispatch('setHighlightedProjectList', {
            projects: this.$store.getters.getProjectIdsByGemeente({id: gemeente.id})
          });
        }
      } 
      else if (this.type === 'thema') {

        let thema = this.$store.getters.getThemaBySlug({
          slug: this.slug
        });

        if (thema) {
          let filterA = ['all', ['has', 'thema_'+thema.id]];
          let filterB = ['all', ['!has', 'thema_'+thema.id]];
          this.$store.map.setFilter('verhalen', filterA);
          this.$store.map.setFilter('verhalen_muted', filterB);

          // Zoom...
          this.$store.dispatch('setHighlightedProjectList', {
            projects: this.$store.getters.getProjectIdsByThema({id: thema.id})
          });
        }

        // let filter = ['all', ['==', 'slug', this.slug]];
        // this.$store.map.setFilter('connections', filter)
        // this.$store.dispatch('setFilters', {
        //   filters: `thema--${this.slug}`
        // });
      }
      else if (this.type === 'partijen') {

        let partij = this.$store.getters.getPartijBySlug({
          slug: this.slug
        });

        if (partij) {
          let filterA = ['all', ['has', 'partij_'+partij.id]];
          let filterB = ['all', ['!has', 'partij_'+partij.id]];
          this.$store.map.setFilter('verhalen', filterA);
          this.$store.map.setFilter('verhalen_muted', filterB);

          // Zoom...
          this.$store.dispatch('setHighlightedProjectList', {
            projects: this.$store.getters.getProjectIdsByPartij({id: partij.id})
          });
        }

        // let filter = ['all', ['==', 'slug', this.slug]];
        // this.$store.map.setFilter('connections', filter)
        // this.$store.dispatch('setFilters', {
        //   filters: `partij--${this.slug}`
        // });
      
      } else {
        // Placeholder... 
        this.active = !this.active;
      }
    }
  },
  destroyed() {
    if (this.$store.map) {
      this.$store.map.setFilter('verhalen', ['all']);
      this.$store.map.setFilter('verhalen_muted', ['==', 'type', 'off']);
    }
  }
}
</script>

<style lang="scss">
  .MapBoxZoom {
    position: relative;
    background: #eff3fa;
    color: black;
    padding: 12px 16px;
    border-radius: 4px;
    font-family: $font_nav;
    font-size: 16px;
    cursor: pointer;
    user-select: none;

    &--labeled {
      padding-left: 48px;
      
      span {
        position: absolute;
        display: flex;
        width: 32px;
        height: 100%;
        top: 0;
        left: 0;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        justify-content: center;
        align-items: center;
      }
    }
    
    &--compact {
      margin: 0;
      padding: 0;
      background: transparent;
      display: inline;
 
      span {
        display: none;
      }
    }

    &--active, &--labeled:hover, span {
      background: #dbe6f3;
    }
    &--active, &:hover {
      color: $metro_oranje;

      span {
        color: black;
      }
    }
  }
</style>
